import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';

import {Provider} from 'react-redux';
import store from './store';


ReactDOM.render(
    // <React.StrictMode>
    <React.Fragment>
        <Provider store={store}>
            <App/>
        </Provider>
    </React.Fragment>,
    // </React.StrictMode>,
    document.getElementById('root')
);
